/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const aiStartChatRequest = /* GraphQL */ `
  mutation AiStartChatRequest($input: AiStartChatRequestInput!) {
    aiStartChatRequest(input: $input) {
      id
      success
      error
    }
  }
`;
export const aiGetChatResponse = /* GraphQL */ `
  mutation AiGetChatResponse($input: AiGetChatResponseInput!) {
    aiGetChatResponse(input: $input) {
      giideId
      script
    }
  }
`;
export const handleGiidePasswords = /* GraphQL */ `
  mutation HandleGiidePasswords($input: GiidePasswordInput!) {
    handleGiidePasswords(input: $input) {
      success
      error
    }
  }
`;
export const unsplashTrackDownload = /* GraphQL */ `
  mutation UnsplashTrackDownload($input: UnsplashTrackDownloadInput) {
    unsplashTrackDownload(input: $input) {
      type
    }
  }
`;
export const paddleUpdateUserPlan = /* GraphQL */ `
  mutation PaddleUpdateUserPlan($input: PaddleUpdateUserPlanInput) {
    paddleUpdateUserPlan(input: $input) {
      planID
      subscriptionID
      error
    }
  }
`;
export const createNewGiide = /* GraphQL */ `
  mutation CreateNewGiide {
    createNewGiide {
      giideID
      userID
      tenantID
      stepID
    }
  }
`;
export const publishGiide = /* GraphQL */ `
  mutation PublishGiide($input: PublishGiideInput) {
    publishGiide(input: $input) {
      result
      error
      code
    }
  }
`;
export const exportVideoStart = /* GraphQL */ `
  mutation ExportVideoStart($input: ExportVideoUpdateInput) {
    exportVideoStart(input: $input) {
      id
      error
      status
      progress
    }
  }
`;
export const exportVideoUpdate = /* GraphQL */ `
  mutation ExportVideoUpdate($input: ExportVideoUpdateInput) {
    exportVideoUpdate(input: $input) {
      id
      error
      status
      progress
    }
  }
`;
export const updateTranscriptContent = /* GraphQL */ `
  mutation UpdateTranscriptContent($input: UpdateTranscriptContentInput) {
    updateTranscriptContent(input: $input) {
      transcript
    }
  }
`;
export const updateGiideEmbedSettings = /* GraphQL */ `
  mutation UpdateGiideEmbedSettings($input: inputUpdateGiideEmbedSettings!) {
    updateGiideEmbedSettings(input: $input) {
      id
      owner
      tenantID
      embedCodeState
      embedCodeAllowedDomains
    }
  }
`;
export const copyGiide = /* GraphQL */ `
  mutation CopyGiide($input: inputCopyGiide!) {
    copyGiide(input: $input) {
      newGiideId
      owner
      tenantID
    }
  }
`;
export const stepReorder = /* GraphQL */ `
  mutation StepReorder($input: StepReorderInput) {
    stepReorder(input: $input) {
      id
      success
      error
    }
  }
`;
export const mobileAppEmail = /* GraphQL */ `
  mutation MobileAppEmail {
    mobileAppEmail {
      success
    }
  }
`;
export const unlinkRecording = /* GraphQL */ `
  mutation UnlinkRecording($input: UnlinkRecordingInput) {
    unlinkRecording(input: $input) {
      success
    }
  }
`;
export const relinkFeedCard = /* GraphQL */ `
  mutation RelinkFeedCard($input: RelinkFeedCardInput) {
    relinkFeedCard(input: $input) {
      success
    }
  }
`;
export const unpublishGiide = /* GraphQL */ `
  mutation UnpublishGiide($input: UnpublishGiideInput) {
    unpublishGiide(input: $input) {
      success
      error
    }
  }
`;
export const deleteGiideAll = /* GraphQL */ `
  mutation DeleteGiideAll($input: DeleteGiideAllInput) {
    deleteGiideAll(input: $input) {
      success
      error
    }
  }
`;
export const updateUserProfile = /* GraphQL */ `
  mutation UpdateUserProfile($input: UpdateUserProfileInput!) {
    updateUserProfile(input: $input) {
      role
      userID
      email
      fullName
      title
      profileImageName
      profileImageService
      profileImageId
      preferences {
        firstLoginVideo
        dontShowPublishInfoTooltip
        dontShowFeedcardWordTooltip
        dontShowGetStartedModal
        dontShowTranscriptAnnouncementBanner
      }
      giidesCreatedListFreePlan {
        createdAt
        giideID
        updatedAt
      }
    }
  }
`;
export const moveFeedCard = /* GraphQL */ `
  mutation MoveFeedCard($input: MoveFeedCardInput) {
    moveFeedCard(input: $input) {
      success
      error
    }
  }
`;
export const selectRecordingFromLibrary = /* GraphQL */ `
  mutation SelectRecordingFromLibrary($input: SelectRecordingFromLibraryInput) {
    selectRecordingFromLibrary(input: $input) {
      success
      error
      filePath
    }
  }
`;
export const copySampleAudio = /* GraphQL */ `
  mutation CopySampleAudio($input: CopySampleAudioInput) {
    copySampleAudio(input: $input) {
      success
      error
      filePath
    }
  }
`;
export const inviteUser = /* GraphQL */ `
  mutation InviteUser($input: InviteUserInput) {
    inviteUser(input: $input) {
      success
      error
    }
  }
`;
export const deleteAllInvites = /* GraphQL */ `
  mutation DeleteAllInvites($input: DeleteAllInvitesInput) {
    deleteAllInvites(input: $input) {
      success
      error
    }
  }
`;
export const updateUserPlanTimeStamp = /* GraphQL */ `
  mutation UpdateUserPlanTimeStamp($input: UpdateUserPlanTimeStampInput!) {
    updateUserPlanTimeStamp(input: $input) {
      id
      versionID
      updatedAt
      createdAt
      price
      name
      features {
        giideMaxLengthAudio {
          name
          createdAt
          isActive
          giideLengthInSeconds
          updatedAt
        }
        giideMaxFileSizeAudio {
          name
          createdAt
          isActive
          giideMaxFileSizeMBAudio
          updatedAt
        }
        giideMaxNumberOfGiides {
          createdAt
          hasLimit
          isActive
          limitAmount
          name
          updatedAt
        }
        chapters {
          name
          createdAt
          isActive
          hasLimit
          maxNumberOfChapters
          allowChaptersWithFutureGiides
          allowChaptersWithExistingGiides
          updatedAt
        }
        recording {
          name
          createdAt
          hasBrowserRecording
          updatedAt
        }
        embedCode {
          name
          createdAt
          isActive
          updatedAt
          allowEmbedCode
        }
        pollQuizFeature {
          name
          createdAt
          isActive
          updatedAt
          allowFeature
        }
        giidePasswordProtection {
          allowGiidePasswordProtection
          createdAt
          isActive
          name
          updatedAt
        }
        giideDuplicate {
          allowGiideDuplicate
          createdAt
          isActive
          name
          updatedAt
        }
      }
      userID
      tenantID
      giidesCreatedListFreePlan {
        giideID
        createdAt
        updatedAt
      }
      giidesCreatedListProPlan {
        giideID
        createdAt
        updatedAt
      }
      subscriptionIDs
      accountStatus
      freeTrialEndDate
      totalGiidesCreated
      upgradePlans
      downgradePlans
      planChangeError
      paddlePlanID
    }
  }
`;
export const createGiide = /* GraphQL */ `
  mutation CreateGiide(
    $input: CreateGiideInput!
    $condition: ModelGiideConditionInput
  ) {
    createGiide(input: $input, condition: $condition) {
      id
      title
      description
      steps {
        items {
          id
          title
          order
          script
          giide {
            id
            title
            description
            tenantID
            publishState
            exportVideoState
            unauthenticatedAccessAllowed
            owner
            createdAt
            updatedAt
            publishedAt
            publishedWithTranscript
            previewedAt
            preview
            isInGiideStudioLibrary
            giideLibraryId
            useOwnDescription
            useOwnAuthorBio
            useGiideTones
            script
            hasChapters
            noindex
            embedCodeState
            embedCodeAllowedDomains
            passwordEnabled
          }
          tenantID
          open
          ownRecordingUploaded
          owner
          createdAt
          updatedAt
          recording {
            id
            deleted
            length
            tenantID
            filePath
            transcriptPath
            transcriptError
            owner
            createdAt
            updatedAt
            giideId
            libraryRecordId
          }
        }
        nextToken
      }
      tenantID
      speaker {
        firstName
        lastName
        fullName
        bio
        title
        socialUrls {
          facebook
          twitter
          linkedin
          website
        }
        profile
        headshotPath
      }
      publishState
      exportVideoState
      unauthenticatedAccessAllowed
      owner
      createdAt
      updatedAt
      publishedAt
      publishedWithTranscript
      previewedAt
      cardDetails {
        cardColor
        cardShade
        thumbnailImg
        thumbnailCustomName
        thumbnailCustomPath
        thumbnailImageService
        useCustomThumbnail
        colorLeft
        colorRight
        thumbnailLarge
        thumbnailSmall
      }
      preview
      isInGiideStudioLibrary
      giideLibraryId
      useOwnDescription
      useOwnAuthorBio
      useGiideTones
      script
      hasChapters
      noindex
      embedCodeState
      embedCodeAllowedDomains
      passwordEnabled
    }
  }
`;
export const updateGiide = /* GraphQL */ `
  mutation UpdateGiide(
    $input: UpdateGiideInput!
    $condition: ModelGiideConditionInput
  ) {
    updateGiide(input: $input, condition: $condition) {
      id
      title
      description
      steps {
        items {
          id
          title
          order
          script
          giide {
            id
            title
            description
            tenantID
            publishState
            exportVideoState
            unauthenticatedAccessAllowed
            owner
            createdAt
            updatedAt
            publishedAt
            publishedWithTranscript
            previewedAt
            preview
            isInGiideStudioLibrary
            giideLibraryId
            useOwnDescription
            useOwnAuthorBio
            useGiideTones
            script
            hasChapters
            noindex
            embedCodeState
            embedCodeAllowedDomains
            passwordEnabled
          }
          tenantID
          open
          ownRecordingUploaded
          owner
          createdAt
          updatedAt
          recording {
            id
            deleted
            length
            tenantID
            filePath
            transcriptPath
            transcriptError
            owner
            createdAt
            updatedAt
            giideId
            libraryRecordId
          }
        }
        nextToken
      }
      tenantID
      speaker {
        firstName
        lastName
        fullName
        bio
        title
        socialUrls {
          facebook
          twitter
          linkedin
          website
        }
        profile
        headshotPath
      }
      publishState
      exportVideoState
      unauthenticatedAccessAllowed
      owner
      createdAt
      updatedAt
      publishedAt
      publishedWithTranscript
      previewedAt
      cardDetails {
        cardColor
        cardShade
        thumbnailImg
        thumbnailCustomName
        thumbnailCustomPath
        thumbnailImageService
        useCustomThumbnail
        colorLeft
        colorRight
        thumbnailLarge
        thumbnailSmall
      }
      preview
      isInGiideStudioLibrary
      giideLibraryId
      useOwnDescription
      useOwnAuthorBio
      useGiideTones
      script
      hasChapters
      noindex
      embedCodeState
      embedCodeAllowedDomains
      passwordEnabled
    }
  }
`;
export const deleteGiide = /* GraphQL */ `
  mutation DeleteGiide(
    $input: DeleteGiideInput!
    $condition: ModelGiideConditionInput
  ) {
    deleteGiide(input: $input, condition: $condition) {
      id
      title
      description
      steps {
        items {
          id
          title
          order
          script
          giide {
            id
            title
            description
            tenantID
            publishState
            exportVideoState
            unauthenticatedAccessAllowed
            owner
            createdAt
            updatedAt
            publishedAt
            publishedWithTranscript
            previewedAt
            preview
            isInGiideStudioLibrary
            giideLibraryId
            useOwnDescription
            useOwnAuthorBio
            useGiideTones
            script
            hasChapters
            noindex
            embedCodeState
            embedCodeAllowedDomains
            passwordEnabled
          }
          tenantID
          open
          ownRecordingUploaded
          owner
          createdAt
          updatedAt
          recording {
            id
            deleted
            length
            tenantID
            filePath
            transcriptPath
            transcriptError
            owner
            createdAt
            updatedAt
            giideId
            libraryRecordId
          }
        }
        nextToken
      }
      tenantID
      speaker {
        firstName
        lastName
        fullName
        bio
        title
        socialUrls {
          facebook
          twitter
          linkedin
          website
        }
        profile
        headshotPath
      }
      publishState
      exportVideoState
      unauthenticatedAccessAllowed
      owner
      createdAt
      updatedAt
      publishedAt
      publishedWithTranscript
      previewedAt
      cardDetails {
        cardColor
        cardShade
        thumbnailImg
        thumbnailCustomName
        thumbnailCustomPath
        thumbnailImageService
        useCustomThumbnail
        colorLeft
        colorRight
        thumbnailLarge
        thumbnailSmall
      }
      preview
      isInGiideStudioLibrary
      giideLibraryId
      useOwnDescription
      useOwnAuthorBio
      useGiideTones
      script
      hasChapters
      noindex
      embedCodeState
      embedCodeAllowedDomains
      passwordEnabled
    }
  }
`;
export const createStep = /* GraphQL */ `
  mutation CreateStep(
    $input: CreateStepInput!
    $condition: ModelStepConditionInput
  ) {
    createStep(input: $input, condition: $condition) {
      id
      title
      order
      script
      giide {
        id
        title
        description
        steps {
          items {
            id
            title
            order
            script
            tenantID
            open
            ownRecordingUploaded
            owner
            createdAt
            updatedAt
          }
          nextToken
        }
        tenantID
        speaker {
          firstName
          lastName
          fullName
          bio
          title
          socialUrls {
            facebook
            twitter
            linkedin
            website
          }
          profile
          headshotPath
        }
        publishState
        exportVideoState
        unauthenticatedAccessAllowed
        owner
        createdAt
        updatedAt
        publishedAt
        publishedWithTranscript
        previewedAt
        cardDetails {
          cardColor
          cardShade
          thumbnailImg
          thumbnailCustomName
          thumbnailCustomPath
          thumbnailImageService
          useCustomThumbnail
          colorLeft
          colorRight
          thumbnailLarge
          thumbnailSmall
        }
        preview
        isInGiideStudioLibrary
        giideLibraryId
        useOwnDescription
        useOwnAuthorBio
        useGiideTones
        script
        hasChapters
        noindex
        embedCodeState
        embedCodeAllowedDomains
        passwordEnabled
      }
      tenantID
      open
      ownRecordingUploaded
      owner
      createdAt
      updatedAt
      recording {
        id
        deleted
        length
        step {
          id
          title
          order
          script
          giide {
            id
            title
            description
            tenantID
            publishState
            exportVideoState
            unauthenticatedAccessAllowed
            owner
            createdAt
            updatedAt
            publishedAt
            publishedWithTranscript
            previewedAt
            preview
            isInGiideStudioLibrary
            giideLibraryId
            useOwnDescription
            useOwnAuthorBio
            useGiideTones
            script
            hasChapters
            noindex
            embedCodeState
            embedCodeAllowedDomains
            passwordEnabled
          }
          tenantID
          open
          ownRecordingUploaded
          owner
          createdAt
          updatedAt
          recording {
            id
            deleted
            length
            tenantID
            filePath
            transcriptPath
            transcriptError
            owner
            createdAt
            updatedAt
            giideId
            libraryRecordId
          }
        }
        feedCards {
          items {
            nonLibraryGiideID
            id
            source
            time
            title
            type
            url
            context
            affiliation
            text
            caption
            question
            feedCardIdForAnalytics
            questionHasCorrectAnswer
            customHeader
            questionType
            resourceType
            iconUrl
            imageUrl
            bold
            term
            tenantID
            numbered
            listItems
            author
            owner
            createdAt
            updatedAt
            firstName
            lastName
            fullName
            expertise
            unlinked
            customImage
            customImageName
            giideId
            feedCardRecordingId
            htmlText
            imageService
          }
          nextToken
        }
        transcriptResults {
          items {
            start_time
            end_time
            type
          }
          transcript
        }
        tenantID
        filePath
        transcriptPath
        transcriptError
        owner
        createdAt
        updatedAt
        giideId
        libraryRecordId
      }
    }
  }
`;
export const updateStep = /* GraphQL */ `
  mutation UpdateStep(
    $input: UpdateStepInput!
    $condition: ModelStepConditionInput
  ) {
    updateStep(input: $input, condition: $condition) {
      id
      title
      order
      script
      giide {
        id
        title
        description
        steps {
          items {
            id
            title
            order
            script
            tenantID
            open
            ownRecordingUploaded
            owner
            createdAt
            updatedAt
          }
          nextToken
        }
        tenantID
        speaker {
          firstName
          lastName
          fullName
          bio
          title
          socialUrls {
            facebook
            twitter
            linkedin
            website
          }
          profile
          headshotPath
        }
        publishState
        exportVideoState
        unauthenticatedAccessAllowed
        owner
        createdAt
        updatedAt
        publishedAt
        publishedWithTranscript
        previewedAt
        cardDetails {
          cardColor
          cardShade
          thumbnailImg
          thumbnailCustomName
          thumbnailCustomPath
          thumbnailImageService
          useCustomThumbnail
          colorLeft
          colorRight
          thumbnailLarge
          thumbnailSmall
        }
        preview
        isInGiideStudioLibrary
        giideLibraryId
        useOwnDescription
        useOwnAuthorBio
        useGiideTones
        script
        hasChapters
        noindex
        embedCodeState
        embedCodeAllowedDomains
        passwordEnabled
      }
      tenantID
      open
      ownRecordingUploaded
      owner
      createdAt
      updatedAt
      recording {
        id
        deleted
        length
        step {
          id
          title
          order
          script
          giide {
            id
            title
            description
            tenantID
            publishState
            exportVideoState
            unauthenticatedAccessAllowed
            owner
            createdAt
            updatedAt
            publishedAt
            publishedWithTranscript
            previewedAt
            preview
            isInGiideStudioLibrary
            giideLibraryId
            useOwnDescription
            useOwnAuthorBio
            useGiideTones
            script
            hasChapters
            noindex
            embedCodeState
            embedCodeAllowedDomains
            passwordEnabled
          }
          tenantID
          open
          ownRecordingUploaded
          owner
          createdAt
          updatedAt
          recording {
            id
            deleted
            length
            tenantID
            filePath
            transcriptPath
            transcriptError
            owner
            createdAt
            updatedAt
            giideId
            libraryRecordId
          }
        }
        feedCards {
          items {
            nonLibraryGiideID
            id
            source
            time
            title
            type
            url
            context
            affiliation
            text
            caption
            question
            feedCardIdForAnalytics
            questionHasCorrectAnswer
            customHeader
            questionType
            resourceType
            iconUrl
            imageUrl
            bold
            term
            tenantID
            numbered
            listItems
            author
            owner
            createdAt
            updatedAt
            firstName
            lastName
            fullName
            expertise
            unlinked
            customImage
            customImageName
            giideId
            feedCardRecordingId
            htmlText
            imageService
          }
          nextToken
        }
        transcriptResults {
          items {
            start_time
            end_time
            type
          }
          transcript
        }
        tenantID
        filePath
        transcriptPath
        transcriptError
        owner
        createdAt
        updatedAt
        giideId
        libraryRecordId
      }
    }
  }
`;
export const deleteStep = /* GraphQL */ `
  mutation DeleteStep(
    $input: DeleteStepInput!
    $condition: ModelStepConditionInput
  ) {
    deleteStep(input: $input, condition: $condition) {
      id
      title
      order
      script
      giide {
        id
        title
        description
        steps {
          items {
            id
            title
            order
            script
            tenantID
            open
            ownRecordingUploaded
            owner
            createdAt
            updatedAt
          }
          nextToken
        }
        tenantID
        speaker {
          firstName
          lastName
          fullName
          bio
          title
          socialUrls {
            facebook
            twitter
            linkedin
            website
          }
          profile
          headshotPath
        }
        publishState
        exportVideoState
        unauthenticatedAccessAllowed
        owner
        createdAt
        updatedAt
        publishedAt
        publishedWithTranscript
        previewedAt
        cardDetails {
          cardColor
          cardShade
          thumbnailImg
          thumbnailCustomName
          thumbnailCustomPath
          thumbnailImageService
          useCustomThumbnail
          colorLeft
          colorRight
          thumbnailLarge
          thumbnailSmall
        }
        preview
        isInGiideStudioLibrary
        giideLibraryId
        useOwnDescription
        useOwnAuthorBio
        useGiideTones
        script
        hasChapters
        noindex
        embedCodeState
        embedCodeAllowedDomains
        passwordEnabled
      }
      tenantID
      open
      ownRecordingUploaded
      owner
      createdAt
      updatedAt
      recording {
        id
        deleted
        length
        step {
          id
          title
          order
          script
          giide {
            id
            title
            description
            tenantID
            publishState
            exportVideoState
            unauthenticatedAccessAllowed
            owner
            createdAt
            updatedAt
            publishedAt
            publishedWithTranscript
            previewedAt
            preview
            isInGiideStudioLibrary
            giideLibraryId
            useOwnDescription
            useOwnAuthorBio
            useGiideTones
            script
            hasChapters
            noindex
            embedCodeState
            embedCodeAllowedDomains
            passwordEnabled
          }
          tenantID
          open
          ownRecordingUploaded
          owner
          createdAt
          updatedAt
          recording {
            id
            deleted
            length
            tenantID
            filePath
            transcriptPath
            transcriptError
            owner
            createdAt
            updatedAt
            giideId
            libraryRecordId
          }
        }
        feedCards {
          items {
            nonLibraryGiideID
            id
            source
            time
            title
            type
            url
            context
            affiliation
            text
            caption
            question
            feedCardIdForAnalytics
            questionHasCorrectAnswer
            customHeader
            questionType
            resourceType
            iconUrl
            imageUrl
            bold
            term
            tenantID
            numbered
            listItems
            author
            owner
            createdAt
            updatedAt
            firstName
            lastName
            fullName
            expertise
            unlinked
            customImage
            customImageName
            giideId
            feedCardRecordingId
            htmlText
            imageService
          }
          nextToken
        }
        transcriptResults {
          items {
            start_time
            end_time
            type
          }
          transcript
        }
        tenantID
        filePath
        transcriptPath
        transcriptError
        owner
        createdAt
        updatedAt
        giideId
        libraryRecordId
      }
    }
  }
`;
export const createRecording = /* GraphQL */ `
  mutation CreateRecording(
    $input: CreateRecordingInput!
    $condition: ModelRecordingConditionInput
  ) {
    createRecording(input: $input, condition: $condition) {
      id
      deleted
      length
      step {
        id
        title
        order
        script
        giide {
          id
          title
          description
          steps {
            nextToken
          }
          tenantID
          speaker {
            firstName
            lastName
            fullName
            bio
            title
            profile
            headshotPath
          }
          publishState
          exportVideoState
          unauthenticatedAccessAllowed
          owner
          createdAt
          updatedAt
          publishedAt
          publishedWithTranscript
          previewedAt
          cardDetails {
            cardColor
            cardShade
            thumbnailImg
            thumbnailCustomName
            thumbnailCustomPath
            thumbnailImageService
            useCustomThumbnail
            colorLeft
            colorRight
            thumbnailLarge
            thumbnailSmall
          }
          preview
          isInGiideStudioLibrary
          giideLibraryId
          useOwnDescription
          useOwnAuthorBio
          useGiideTones
          script
          hasChapters
          noindex
          embedCodeState
          embedCodeAllowedDomains
          passwordEnabled
        }
        tenantID
        open
        ownRecordingUploaded
        owner
        createdAt
        updatedAt
        recording {
          id
          deleted
          length
          step {
            id
            title
            order
            script
            tenantID
            open
            ownRecordingUploaded
            owner
            createdAt
            updatedAt
          }
          feedCards {
            nextToken
          }
          transcriptResults {
            transcript
          }
          tenantID
          filePath
          transcriptPath
          transcriptError
          owner
          createdAt
          updatedAt
          giideId
          libraryRecordId
        }
      }
      feedCards {
        items {
          nonLibraryGiideID
          id
          source
          time
          title
          type
          url
          context
          affiliation
          text
          caption
          question
          feedCardIdForAnalytics
          questionHasCorrectAnswer
          customHeader
          questionType
          answerDetails {
            userAnswer
            userAnswerIsCorrect
            correctAnswerIndex
          }
          resourceType
          iconUrl
          imageUrl
          socialUrls {
            facebook
            twitter
            linkedin
            website
          }
          bold
          term
          tenantID
          numbered
          listItems
          author
          owner
          createdAt
          updatedAt
          firstName
          lastName
          fullName
          expertise
          unlinked
          customImage
          customImageName
          giideId
          feedCardRecordingId
          imageDetails {
            url
            description
            altDescription
            attributionUserName
            width
            height
            attributionFirstName
            attributionLastName
            attributionFullName
            caption
            imageTypeSelected
          }
          htmlText
          imageService
          recording {
            id
            deleted
            length
            tenantID
            filePath
            transcriptPath
            transcriptError
            owner
            createdAt
            updatedAt
            giideId
            libraryRecordId
          }
        }
        nextToken
      }
      transcriptResults {
        items {
          alternatives {
            confidence
            content
          }
          start_time
          end_time
          type
        }
        transcript
      }
      tenantID
      filePath
      transcriptPath
      transcriptError
      owner
      createdAt
      updatedAt
      giideId
      libraryRecordId
    }
  }
`;
export const deleteRecording = /* GraphQL */ `
  mutation DeleteRecording(
    $input: DeleteRecordingInput!
    $condition: ModelRecordingConditionInput
  ) {
    deleteRecording(input: $input, condition: $condition) {
      id
      deleted
      length
      step {
        id
        title
        order
        script
        giide {
          id
          title
          description
          steps {
            nextToken
          }
          tenantID
          speaker {
            firstName
            lastName
            fullName
            bio
            title
            profile
            headshotPath
          }
          publishState
          exportVideoState
          unauthenticatedAccessAllowed
          owner
          createdAt
          updatedAt
          publishedAt
          publishedWithTranscript
          previewedAt
          cardDetails {
            cardColor
            cardShade
            thumbnailImg
            thumbnailCustomName
            thumbnailCustomPath
            thumbnailImageService
            useCustomThumbnail
            colorLeft
            colorRight
            thumbnailLarge
            thumbnailSmall
          }
          preview
          isInGiideStudioLibrary
          giideLibraryId
          useOwnDescription
          useOwnAuthorBio
          useGiideTones
          script
          hasChapters
          noindex
          embedCodeState
          embedCodeAllowedDomains
          passwordEnabled
        }
        tenantID
        open
        ownRecordingUploaded
        owner
        createdAt
        updatedAt
        recording {
          id
          deleted
          length
          step {
            id
            title
            order
            script
            tenantID
            open
            ownRecordingUploaded
            owner
            createdAt
            updatedAt
          }
          feedCards {
            nextToken
          }
          transcriptResults {
            transcript
          }
          tenantID
          filePath
          transcriptPath
          transcriptError
          owner
          createdAt
          updatedAt
          giideId
          libraryRecordId
        }
      }
      feedCards {
        items {
          nonLibraryGiideID
          id
          source
          time
          title
          type
          url
          context
          affiliation
          text
          caption
          question
          feedCardIdForAnalytics
          questionHasCorrectAnswer
          customHeader
          questionType
          answerDetails {
            userAnswer
            userAnswerIsCorrect
            correctAnswerIndex
          }
          resourceType
          iconUrl
          imageUrl
          socialUrls {
            facebook
            twitter
            linkedin
            website
          }
          bold
          term
          tenantID
          numbered
          listItems
          author
          owner
          createdAt
          updatedAt
          firstName
          lastName
          fullName
          expertise
          unlinked
          customImage
          customImageName
          giideId
          feedCardRecordingId
          imageDetails {
            url
            description
            altDescription
            attributionUserName
            width
            height
            attributionFirstName
            attributionLastName
            attributionFullName
            caption
            imageTypeSelected
          }
          htmlText
          imageService
          recording {
            id
            deleted
            length
            tenantID
            filePath
            transcriptPath
            transcriptError
            owner
            createdAt
            updatedAt
            giideId
            libraryRecordId
          }
        }
        nextToken
      }
      transcriptResults {
        items {
          alternatives {
            confidence
            content
          }
          start_time
          end_time
          type
        }
        transcript
      }
      tenantID
      filePath
      transcriptPath
      transcriptError
      owner
      createdAt
      updatedAt
      giideId
      libraryRecordId
    }
  }
`;
export const createUserAudioLibrary = /* GraphQL */ `
  mutation CreateUserAudioLibrary(
    $input: CreateUserAudioLibraryInput!
    $condition: ModelUserAudioLibraryConditionInput
  ) {
    createUserAudioLibrary(input: $input, condition: $condition) {
      id
      audioUrl
      createdAt
      durationSeconds
      tenantID
      title
      updatedAt
      userID
      state
      errorMessage
      errorMessageDisplayToUser
      originalFileExtension
      originalFileMimeType
      uploadSource
    }
  }
`;
export const deleteUserAudioLibrary = /* GraphQL */ `
  mutation DeleteUserAudioLibrary(
    $input: DeleteUserAudioLibraryInput!
    $condition: ModelUserAudioLibraryConditionInput
  ) {
    deleteUserAudioLibrary(input: $input, condition: $condition) {
      id
      audioUrl
      createdAt
      durationSeconds
      tenantID
      title
      updatedAt
      userID
      state
      errorMessage
      errorMessageDisplayToUser
      originalFileExtension
      originalFileMimeType
      uploadSource
    }
  }
`;
export const createUserImageRecord = /* GraphQL */ `
  mutation CreateUserImageRecord($input: CreateOrUpdateUserImageRecordInput!) {
    createUserImageRecord(input: $input) {
      id
      userID
      feedCardId
      imageUrl
      type
      imageService
      createdAt
      fileName
      state
      originalFileExtension
      originalFileMimeType
      errorMessage
      errorMessageDisplayToUser
    }
  }
`;
export const updateUserImageRecord = /* GraphQL */ `
  mutation UpdateUserImageRecord($input: CreateOrUpdateUserImageRecordInput!) {
    updateUserImageRecord(input: $input) {
      id
      userID
      feedCardId
      imageUrl
      type
      imageService
      createdAt
      fileName
      state
      originalFileExtension
      originalFileMimeType
      errorMessage
      errorMessageDisplayToUser
    }
  }
`;
export const createFeedCard = /* GraphQL */ `
  mutation CreateFeedCard(
    $input: CreateFeedCardInput!
    $condition: ModelFeedCardConditionInput
  ) {
    createFeedCard(input: $input, condition: $condition) {
      nonLibraryGiideID
      id
      source
      time
      title
      type
      url
      context
      affiliation
      text
      caption
      question
      feedCardIdForAnalytics
      questionHasCorrectAnswer
      customHeader
      questionType
      answerDetails {
        answerOptions {
          index
          sortOrder
          text
        }
        userAnswer
        userAnswerIsCorrect
        correctAnswerIndex
      }
      resourceType
      iconUrl
      imageUrl
      socialUrls {
        facebook
        twitter
        linkedin
        website
      }
      bold
      term
      tenantID
      numbered
      listItems
      author
      owner
      createdAt
      updatedAt
      firstName
      lastName
      fullName
      expertise
      unlinked
      customImage
      customImageName
      giideId
      feedCardRecordingId
      imageDetails {
        url
        description
        altDescription
        attributionUserName
        width
        height
        attributionFirstName
        attributionLastName
        attributionFullName
        caption
        imageTypeSelected
        userUploadedImageDetails {
          customImageName
        }
      }
      htmlText
      imageService
      recording {
        id
        deleted
        length
        step {
          id
          title
          order
          script
          giide {
            id
            title
            description
            tenantID
            publishState
            exportVideoState
            unauthenticatedAccessAllowed
            owner
            createdAt
            updatedAt
            publishedAt
            publishedWithTranscript
            previewedAt
            preview
            isInGiideStudioLibrary
            giideLibraryId
            useOwnDescription
            useOwnAuthorBio
            useGiideTones
            script
            hasChapters
            noindex
            embedCodeState
            embedCodeAllowedDomains
            passwordEnabled
          }
          tenantID
          open
          ownRecordingUploaded
          owner
          createdAt
          updatedAt
          recording {
            id
            deleted
            length
            tenantID
            filePath
            transcriptPath
            transcriptError
            owner
            createdAt
            updatedAt
            giideId
            libraryRecordId
          }
        }
        feedCards {
          items {
            nonLibraryGiideID
            id
            source
            time
            title
            type
            url
            context
            affiliation
            text
            caption
            question
            feedCardIdForAnalytics
            questionHasCorrectAnswer
            customHeader
            questionType
            resourceType
            iconUrl
            imageUrl
            bold
            term
            tenantID
            numbered
            listItems
            author
            owner
            createdAt
            updatedAt
            firstName
            lastName
            fullName
            expertise
            unlinked
            customImage
            customImageName
            giideId
            feedCardRecordingId
            htmlText
            imageService
          }
          nextToken
        }
        transcriptResults {
          items {
            start_time
            end_time
            type
          }
          transcript
        }
        tenantID
        filePath
        transcriptPath
        transcriptError
        owner
        createdAt
        updatedAt
        giideId
        libraryRecordId
      }
    }
  }
`;
export const updateFeedCard = /* GraphQL */ `
  mutation UpdateFeedCard(
    $input: UpdateFeedCardInput!
    $condition: ModelFeedCardConditionInput
  ) {
    updateFeedCard(input: $input, condition: $condition) {
      nonLibraryGiideID
      id
      source
      time
      title
      type
      url
      context
      affiliation
      text
      caption
      question
      feedCardIdForAnalytics
      questionHasCorrectAnswer
      customHeader
      questionType
      answerDetails {
        answerOptions {
          index
          sortOrder
          text
        }
        userAnswer
        userAnswerIsCorrect
        correctAnswerIndex
      }
      resourceType
      iconUrl
      imageUrl
      socialUrls {
        facebook
        twitter
        linkedin
        website
      }
      bold
      term
      tenantID
      numbered
      listItems
      author
      owner
      createdAt
      updatedAt
      firstName
      lastName
      fullName
      expertise
      unlinked
      customImage
      customImageName
      giideId
      feedCardRecordingId
      imageDetails {
        url
        description
        altDescription
        attributionUserName
        width
        height
        attributionFirstName
        attributionLastName
        attributionFullName
        caption
        imageTypeSelected
        userUploadedImageDetails {
          customImageName
        }
      }
      htmlText
      imageService
      recording {
        id
        deleted
        length
        step {
          id
          title
          order
          script
          giide {
            id
            title
            description
            tenantID
            publishState
            exportVideoState
            unauthenticatedAccessAllowed
            owner
            createdAt
            updatedAt
            publishedAt
            publishedWithTranscript
            previewedAt
            preview
            isInGiideStudioLibrary
            giideLibraryId
            useOwnDescription
            useOwnAuthorBio
            useGiideTones
            script
            hasChapters
            noindex
            embedCodeState
            embedCodeAllowedDomains
            passwordEnabled
          }
          tenantID
          open
          ownRecordingUploaded
          owner
          createdAt
          updatedAt
          recording {
            id
            deleted
            length
            tenantID
            filePath
            transcriptPath
            transcriptError
            owner
            createdAt
            updatedAt
            giideId
            libraryRecordId
          }
        }
        feedCards {
          items {
            nonLibraryGiideID
            id
            source
            time
            title
            type
            url
            context
            affiliation
            text
            caption
            question
            feedCardIdForAnalytics
            questionHasCorrectAnswer
            customHeader
            questionType
            resourceType
            iconUrl
            imageUrl
            bold
            term
            tenantID
            numbered
            listItems
            author
            owner
            createdAt
            updatedAt
            firstName
            lastName
            fullName
            expertise
            unlinked
            customImage
            customImageName
            giideId
            feedCardRecordingId
            htmlText
            imageService
          }
          nextToken
        }
        transcriptResults {
          items {
            start_time
            end_time
            type
          }
          transcript
        }
        tenantID
        filePath
        transcriptPath
        transcriptError
        owner
        createdAt
        updatedAt
        giideId
        libraryRecordId
      }
    }
  }
`;
export const deleteFeedCard = /* GraphQL */ `
  mutation DeleteFeedCard(
    $input: DeleteFeedCardInput!
    $condition: ModelFeedCardConditionInput
  ) {
    deleteFeedCard(input: $input, condition: $condition) {
      nonLibraryGiideID
      id
      source
      time
      title
      type
      url
      context
      affiliation
      text
      caption
      question
      feedCardIdForAnalytics
      questionHasCorrectAnswer
      customHeader
      questionType
      answerDetails {
        answerOptions {
          index
          sortOrder
          text
        }
        userAnswer
        userAnswerIsCorrect
        correctAnswerIndex
      }
      resourceType
      iconUrl
      imageUrl
      socialUrls {
        facebook
        twitter
        linkedin
        website
      }
      bold
      term
      tenantID
      numbered
      listItems
      author
      owner
      createdAt
      updatedAt
      firstName
      lastName
      fullName
      expertise
      unlinked
      customImage
      customImageName
      giideId
      feedCardRecordingId
      imageDetails {
        url
        description
        altDescription
        attributionUserName
        width
        height
        attributionFirstName
        attributionLastName
        attributionFullName
        caption
        imageTypeSelected
        userUploadedImageDetails {
          customImageName
        }
      }
      htmlText
      imageService
      recording {
        id
        deleted
        length
        step {
          id
          title
          order
          script
          giide {
            id
            title
            description
            tenantID
            publishState
            exportVideoState
            unauthenticatedAccessAllowed
            owner
            createdAt
            updatedAt
            publishedAt
            publishedWithTranscript
            previewedAt
            preview
            isInGiideStudioLibrary
            giideLibraryId
            useOwnDescription
            useOwnAuthorBio
            useGiideTones
            script
            hasChapters
            noindex
            embedCodeState
            embedCodeAllowedDomains
            passwordEnabled
          }
          tenantID
          open
          ownRecordingUploaded
          owner
          createdAt
          updatedAt
          recording {
            id
            deleted
            length
            tenantID
            filePath
            transcriptPath
            transcriptError
            owner
            createdAt
            updatedAt
            giideId
            libraryRecordId
          }
        }
        feedCards {
          items {
            nonLibraryGiideID
            id
            source
            time
            title
            type
            url
            context
            affiliation
            text
            caption
            question
            feedCardIdForAnalytics
            questionHasCorrectAnswer
            customHeader
            questionType
            resourceType
            iconUrl
            imageUrl
            bold
            term
            tenantID
            numbered
            listItems
            author
            owner
            createdAt
            updatedAt
            firstName
            lastName
            fullName
            expertise
            unlinked
            customImage
            customImageName
            giideId
            feedCardRecordingId
            htmlText
            imageService
          }
          nextToken
        }
        transcriptResults {
          items {
            start_time
            end_time
            type
          }
          transcript
        }
        tenantID
        filePath
        transcriptPath
        transcriptError
        owner
        createdAt
        updatedAt
        giideId
        libraryRecordId
      }
    }
  }
`;
export const deleteFeedCardResources = /* GraphQL */ `
  mutation DeleteFeedCardResources($input: DeleteFeedCardInput!) {
    deleteFeedCardResources(input: $input) {
      success
      error
    }
  }
`;
export const updateRecording = /* GraphQL */ `
  mutation UpdateRecording(
    $input: UpdateRecordingInput!
    $condition: ModelRecordingConditionInput
  ) {
    updateRecording(input: $input, condition: $condition) {
      id
      deleted
      length
      step {
        id
        title
        order
        script
        giide {
          id
          title
          description
          steps {
            nextToken
          }
          tenantID
          speaker {
            firstName
            lastName
            fullName
            bio
            title
            profile
            headshotPath
          }
          publishState
          exportVideoState
          unauthenticatedAccessAllowed
          owner
          createdAt
          updatedAt
          publishedAt
          publishedWithTranscript
          previewedAt
          cardDetails {
            cardColor
            cardShade
            thumbnailImg
            thumbnailCustomName
            thumbnailCustomPath
            thumbnailImageService
            useCustomThumbnail
            colorLeft
            colorRight
            thumbnailLarge
            thumbnailSmall
          }
          preview
          isInGiideStudioLibrary
          giideLibraryId
          useOwnDescription
          useOwnAuthorBio
          useGiideTones
          script
          hasChapters
          noindex
          embedCodeState
          embedCodeAllowedDomains
          passwordEnabled
        }
        tenantID
        open
        ownRecordingUploaded
        owner
        createdAt
        updatedAt
        recording {
          id
          deleted
          length
          step {
            id
            title
            order
            script
            tenantID
            open
            ownRecordingUploaded
            owner
            createdAt
            updatedAt
          }
          feedCards {
            nextToken
          }
          transcriptResults {
            transcript
          }
          tenantID
          filePath
          transcriptPath
          transcriptError
          owner
          createdAt
          updatedAt
          giideId
          libraryRecordId
        }
      }
      feedCards {
        items {
          nonLibraryGiideID
          id
          source
          time
          title
          type
          url
          context
          affiliation
          text
          caption
          question
          feedCardIdForAnalytics
          questionHasCorrectAnswer
          customHeader
          questionType
          answerDetails {
            userAnswer
            userAnswerIsCorrect
            correctAnswerIndex
          }
          resourceType
          iconUrl
          imageUrl
          socialUrls {
            facebook
            twitter
            linkedin
            website
          }
          bold
          term
          tenantID
          numbered
          listItems
          author
          owner
          createdAt
          updatedAt
          firstName
          lastName
          fullName
          expertise
          unlinked
          customImage
          customImageName
          giideId
          feedCardRecordingId
          imageDetails {
            url
            description
            altDescription
            attributionUserName
            width
            height
            attributionFirstName
            attributionLastName
            attributionFullName
            caption
            imageTypeSelected
          }
          htmlText
          imageService
          recording {
            id
            deleted
            length
            tenantID
            filePath
            transcriptPath
            transcriptError
            owner
            createdAt
            updatedAt
            giideId
            libraryRecordId
          }
        }
        nextToken
      }
      transcriptResults {
        items {
          alternatives {
            confidence
            content
          }
          start_time
          end_time
          type
        }
        transcript
      }
      tenantID
      filePath
      transcriptPath
      transcriptError
      owner
      createdAt
      updatedAt
      giideId
      libraryRecordId
    }
  }
`;
export const updateUserAudioLibrary = /* GraphQL */ `
  mutation UpdateUserAudioLibrary(
    $input: UpdateUserAudioLibraryInput!
    $condition: ModelUserAudioLibraryConditionInput
  ) {
    updateUserAudioLibrary(input: $input, condition: $condition) {
      id
      audioUrl
      createdAt
      durationSeconds
      tenantID
      title
      updatedAt
      userID
      state
      errorMessage
      errorMessageDisplayToUser
      originalFileExtension
      originalFileMimeType
      uploadSource
    }
  }
`;
